<template>
    <div>
        <top></top>
        <div class="container">
            <breadcrumb :url="url"></breadcrumb>
            <div class="table">
                <el-table
                    :data="tableData"
                    ref="multipleTable"
                    tooltip-effect="dark"
                    style="width: 100%"
                    border
                    :cell-style="{ textAlign: 'center' }"
                    :header-cell-style="{textAlign: 'center'}"
                    @selection-change="handleSelectionChange"

                >

                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column label="商品名称" width="300">
                        <template slot-scope="scope">
                            <div class="flex ali-cen" @click="cartOrder(scope.row.goods.id)">
                                <img
                                    :src="scope.row.goods.image"
                                    alt=""
                                    style="width: 95px;height: 87px;margin-right: 10px;"
                                />
                                <span>{{ scope.row.goods.title }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品编码">
                        <template slot-scope="scope">
                            <div style="color: #999;">
                                {{ scope.row.sku_price.sn }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="属性">
                        <template slot-scope="scope">
                            <div style="color: #999;">
                                {{ scope.row.sku_price.goods_sku_text }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="单价">
                        <template slot-scope="scope">
                            <div class="black">
                                ￥{{ scope.row.sku_price.price }}
                            </div>
                            <div
                                style="text-decoration:line-through;color: #999;"
                            >
                                ￥{{ scope.row.goods.original_price }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="数量" width="200">
                        <template slot-scope="scope">
                            <el-input-number
                                v-model="scope.row.goods_num"
                                :min="1"
                                @change="
                                    onChangeNum($event, scope.row,scope.$index,scope.row)
                                "
                                size="mini"
                            ></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column label="小计">
                        <template slot-scope="scope">
                            <div style="color: #FF6701;">
                                ￥{{ scope.row.sku_price.price }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div
                                @click="changeCart('delete', null, [scope.row.id])"
                                style="cursor:pointer"
                            >
                                删除
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="table-bottom F-flex" style="font-size: 20px;">
                    <el-checkbox v-model="allCart" @change="toggleAllSelection"
                        >全选</el-checkbox
                    >
                    <div
                        style="color: #0093F8;font-size: 20px;"
                        @click="clearCart"
                    >
                        清空购物车
                    </div>
                    <div>
                        已选商品
                        <span style="color: #FF6701;font-size: 29px;">{{
                            num
                        }}</span>
                        件
                    </div>
                    <div>
                        总价（不含运费）：<span
                            style="color: #FF6701;font-size: 29px;"
                            >¥ {{ allMoney }}</span
                        >
                    </div>
                    <el-button @click="jumpConfirm">立即结算</el-button>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import top from "../../components/top.vue";
import breadcrumb from "../../components/breadcrumb.vue";
import bottom from "../../components/bottom.vue";
import { mapActions, mapState,mapGetters } from "vuex";
import {
editCart
} from "@/api/index.js";
if (localStorage.getItem("userInfo")) {
  var token = JSON.parse(localStorage.getItem("userInfo")).token;
  var header = {
    "Content-Type": "application/json",
    token: token,
    platform: "H5",
  };
}
export default {
    components: {
        top,
        breadcrumb,
        bottom
    },
    data() {
        return {
            url: [
                {
                    name: "购物车",
                    url: "/cart"
                }
            ],
            allCart: false,
            num: '0',
            allMoney: 0,
            cartIds: [],
            confirmList: [],

        };
    },
    computed: {
        ...mapState({
            tableData: state => state.cartList
        })
    },
    created() {
        this.getCartList();
        //console.log(this.tableData, "购物车列表");
    },
    methods: {
        ...mapActions(["getCartList", "changeCartList"]),
        handleSelectionChange(val) {
            console.log(val, "ooo");
            this.cartIds = [];
            if (this.tableData.length != val.length) {
                this.allCart = false;
            } else {
                this.allCart = true;
            }
            //this.num = val.length;
            console.log(val);
            this.confirmList = val;
            console.log(this.confirmList);
            let money = 0;
            let nums = 0
            val.forEach(i => {
                nums+=i.goods_num;
                (money = money + Number(i.sku_price.price) * i.goods_num),
                this.cartIds.push(i.id);
            });

            this.allMoney = money;
            this.num = nums
        },

        clearCart() {
            let cartIds = [];
            this.tableData.forEach(i => {
                cartIds.push(i.id);
            });
            this.changeCart("delete", null, cartIds);
        },
        toggleAllSelection(e) {
            if (!e) {
                this.$refs.multipleTable.clearSelection();
            } else {
                this.$refs.multipleTable.clearSelection();
                this.$refs.multipleTable.toggleAllSelection();
            }
        },
         changeCart(type, value = null, id) {
            let obj = {
                act: type,
                cart_list: this.cartIds,
                value: value
            };
            if (id) {
                obj.cart_list = id;
            }

            this.changeCartList(obj);

        },
        jumpConfirm() {
            if (this.num == 0) {
                this.$message.error("请选择结算数据");
                return;
            }
            let arr = [];
            console.log(this.confirmList);
            this.confirmList.forEach(i => {
                arr.push({
                    goods_id: i.goods_id,
                    goods_num: i.goods_num,
                    goods_price: i.sku_price.price,
                    sku_price_id: i.sku_price_id
                });
            });
            console.log(JSON.stringify(arr));
            //.replace(/\[|]/g,'')
            this.$router.push({
            	path: 'confirm',
            	query: {goods:JSON.stringify(arr),from: 'cart' }
            });
        },
        cartOrder(id){
        console.log(id);
        this.$router.push({path:'/info',query:{id:id}})
        },
        onChangeNum(e,g,index){
        console.log(this.confirmList);
        let m = null;
        let nu =null
        this.confirmList.forEach((i,index) => {
         nu+=i.goods_num
         m += Number(i.sku_price.price) * i.goods_num
         return
        });
        console.log(m);
        if(m==null || nu==null){
        this.allMoney = 0;
        this.num = 0;
        return
        }
        this.allMoney = m;
        this.num = nu;
        }
    }
};
</script>
<style>
.table-bottom {
    height: 106px;
    border: solid 1px #ebeef5;
    border-top: none;
    margin-bottom: 20px;
    padding: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/cart.vue